'use strict';

var processInclude = require('./util');

//TODO move spinner import into global import
require('base/components/spinner');

$(document).ready(function () {
  processInclude(require('./product/detail'));
});
